// extracted by mini-css-extract-plugin
export default {"clCheckbox":"checkbox_clCheckbox__jXCGl"};